<template>
  <widget-container
    :url="url"
    headlineclass
    cardclass="ma-0 pa-1"
    color="transparent"
    :bus="bus"
    :dark="false"
    :flat="true"
    :alwaysrender="true"
    @ready="setData"
  >
    <template slot="content">
      <div class>
        <v-row align="center">
          <v-col class="py-0">
            <v-subheader class="title">Top Agents</v-subheader>
            <v-data-table
              class="mb-4"
              :headers="headers"
              :items="data"
              dense
              :loading="loading"
              :sort-by="['ca']"
              :sort-desc="true"
              :hide-default-footer="true"
              :header-props="{ sortByText: 'Trier par' }"
            >
            <template #item.ca="a">
                {{a.item.ca | currency('EUR')}}
            </template>
            </v-data-table>
          </v-col>
        </v-row>
      </div>
    </template>
  </widget-container>
</template>
<script>
import WidgetContainer from "./WidgetContainer";
export default {
  name: "WidgetCrmTopAgent",
  components: { WidgetContainer },
  props: {
    bus: {
      type: Object,
      required: true,
    },
    url: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      data: [],
      headers: [
        { text: "Agent", value: "agentName", sortable: true },
        { text: "Ca", value: "ca", sortable: true, width: "100px" },
      ],
    };
  },
  created() {
    this.$nextTick(() => {
      this.bus.$on("search", () => {
        this.loading = true;
      });
    });
  },
  destroyed() {
    this.bus.$off("search");
  },
  methods: {
    setData(data) {
      this.data = data;
      this.loading = false;
    },
  },
};
</script>